export default "__VITE_ASSET__B75KOlny__"